import React, { useEffect, useState, useMemo } from "react";
import SectionHeader from "../../components/sectionHeader/sectionHeader";
import Card from "../../components/card/card";
import { getApiInstance } from "../../utils/api";
import InputSearch from "../../components/inputs/inputSearch/inputSearch";
import "../mobiliarioCentral/mobiliarioCentral.scss";
import { useParams, useSearchParams } from "react-router-dom";
import Button from "../../components/button/button";
import { IoReloadOutline } from "react-icons/io5";
import { searchByKeywords } from "../../utils/searchUtils";

export default function MueblesSueltos() {
    const [muebles, setMuebles] = useState([]);
    const [viewMode, setViewMode] = useState("square");
    const [searchParams, setSearchParams] = useSearchParams();
    const [searchTerm, setSearchTerm] = useState("");
    const [showFilters, setShowFilters] = useState(false);
    const [visibleCount, setVisibleCount] = useState(15);
    const [allMuebles, setAllMuebles] = useState([]);
    const { subcategoria } = useParams();
    const [allGlobal, setAllGlobal] = useState(null);
    const [loadingGlobal, setLoadingGlobal] = useState(false);

    useEffect(() => {
    const term = searchParams.get("q") || "";
    setSearchTerm(term);
}, [searchParams]);

useEffect(() => {
  const loadAll = async () => {
    if (!searchTerm || allGlobal) return; // ya cargado o no hace falta
    try {
      setLoadingGlobal(true);
      const api = getApiInstance();
      const res = await api.get('/api/Mueble/GetMueblesCatalogo');
      setAllGlobal(res.data);
    } catch (e) {
      console.error('Error cargando catálogo global', e);
    } finally {
      setLoadingGlobal(false);
    }
  };
  loadAll();
}, [searchTerm, allGlobal]);


    const subcategoriaCodigos = {
        munich: [9],
        copenhague: [10],
        miami: [11],
        "make-up-400": [8],
        todo: [],
    };

    // Mapeo de códigos de categoría a nombres descriptivos
    const categoriasMap = {
        8: "Make Up 400",
        9: "Munich",
        10: "Copenhague", 
        11: "Miami"
    };

    useEffect(() => {
        fetchMuebles(subcategoria);
    }, [subcategoria]);

    // Función para verificar propiedades anidadas de forma segura
    const getSafeProperty = (obj, path, defaultValue = null) => {
        return path
            .split(".")
            .reduce(
                (acc, part) =>
                    acc && acc.hasOwnProperty(part) ? acc[part] : defaultValue,
                obj
            );
    };

    const fetchMuebles = async (subcategoriaKey) => {
        try {
            const api = await getApiInstance();
            const codsCategoria = subcategoriaCodigos[subcategoriaKey] || [];
            const codFamilia = 6;

            let responseData = [];

            if (subcategoriaKey === "todo") {
                const response = await api.get(
                    `/api/Mueble/GetMueblesByFamilia/${codFamilia}`
                );
                responseData = response.data;
            } else {
                const endpointBase = `/api/Mueble/GetMueblesByFamiliaCategoria?codFamilia=${codFamilia}&codCategoria=`;

                const promises = codsCategoria.map((cod) =>
                    api
                        .get(`${endpointBase}${cod}`)
                        .catch((err) =>
                            console.error(
                                `Error fetching category ${cod}:`,
                                err
                            )
                        )
                );
                const responses = await Promise.all(promises);
                responseData = responses.flatMap((res) => res?.data || []);
            }

            const enrichedMuebles = await Promise.all(
                responseData.map(async (mueble) => {
                    try {
                        const detailResponse = await api.get(
                            `/api/Mueble/GetDetalleMueble/${mueble.codMueble}`
                        );
                        return {
                            ...mueble,
                            dotacionesFijasPorTienda:
                                detailResponse.data.dotacionesFijasPorTienda ||
                                [],
                            comentarios:
                                detailResponse.data.comentarios || null,
                        };
                    } catch (error) {
                        console.error(
                            `Error fetching details for mueble ${mueble.codMueble}:`,
                            error
                        );
                        return {
                            ...mueble,
                            dotacionesFijasPorTienda: [],
                            comentarios: null,
                        };
                    }
                })
            );

            setMuebles(enrichedMuebles);
            setAllMuebles(enrichedMuebles);
            setVisibleCount(15);

            if (enrichedMuebles.length > 0) {
                console.log(
                    "Estructura del primer mueble:",
                    enrichedMuebles[0]
                );
                console.log(
                    "Dotaciones:",
                    enrichedMuebles[0].dotacionesFijasPorTienda
                );
                console.log("Comentarios:", enrichedMuebles[0].comentarios);
            }
        } catch (error) {
            console.error("Error fetching muebles:", error);
            setMuebles([]);
        }
    };

    const handleSearch = (term) => {
        setVisibleCount(15);
    setSearchParams((prev) => {
        const newParams = new URLSearchParams(prev);
        if (term) {
            newParams.set("q", term);
        } else {
            newParams.delete("q");
        }
        return newParams;
    });
};


    const handleViewModeChange = (mode) => {
        setViewMode(mode);
    };

    const handleFilter = () => {
        setShowFilters(!showFilters);
    };

const filteredMuebles = useMemo(() => {
    if (!searchTerm) return muebles;
    const base = allGlobal ?? muebles;
    return searchByKeywords(base, searchTerm, ["referencia", "nombreBook"]);
}, [searchTerm, muebles, allGlobal]);


    const visibleMuebles = filteredMuebles.slice(0, visibleCount);

    return (
        <div className="mobiliario-central">
            <SectionHeader
                title={`Dotación - ${subcategoria || "Todo"}`}
                onSearch={setSearchTerm}
                onChangeView={handleViewModeChange}
                onFilter={handleFilter}
            />

            <div className="mobiliario-central__header">
                <div className="mobiliario-central__header__search">
                    <InputSearch
                        context="tableSearch"
                        value={searchTerm}
                        onSearch={handleSearch}
                        placeholder="Buscar muebles..."
                    />
                </div>
            </div>

            <div
                className={`mobiliario-central__cards mobiliario-central__cards--${viewMode}`}
            >
                {visibleMuebles.length > 0 ? (
                    viewMode === "square" ? (
                        visibleMuebles.map((mueble) => {
                            // Obtener propiedades de forma segura
                            const dotaciones = getSafeProperty(
                                mueble,
                                "dotacionesFijasPorTienda",
                                []
                            );
                            const comentarios = getSafeProperty(
                                mueble,
                                "comentarios",
                                null
                            );

                            return (
                                <Card
                                    key={mueble.codMueble}
                                    title={mueble.nombreBook}
                                    reference={mueble.referencia}
                                    codCategoria={
                                        // Primera opción: si tiene codCategorias (números), mapear a nombres
                                        mueble.codCategorias && mueble.codCategorias.length > 0 
                                            ? mueble.codCategorias.map(codigo => categoriasMap[codigo] || codigo).join(", ")
                                            // Segunda opción: si tiene categorias (strings), usar directamente
                                            : mueble.categorias && mueble.categorias.length > 0
                                                ? mueble.categorias.join(", ")
                                                : null
                                    }
                                    thumbnail={mueble.rutaImagen}
                                    mode={viewMode}
                                    showButton={true}
                                    link={`/ficha-producto/${mueble.codMueble}`}
                                />
                            );
                        })
                    ) : (
                        <div className="mobiliario-central__cards--row">
                            {visibleMuebles.map((mueble) => {
                                const dotaciones = getSafeProperty(
                                    mueble,
                                    "dotacionesFijasPorTienda",
                                    []
                                );
                                const comentarios = getSafeProperty(
                                    mueble,
                                    "comentarios",
                                    null
                                );

                                return (
                                    <>
                                        <Card
                                            key={mueble.codMueble}
                                            title={mueble.nombreBook}
                                            reference={mueble.referencia}
                                            codCategoria={
                                                // Primera opción: si tiene codCategorias (números), mapear a nombres
                                                mueble.codCategorias && mueble.codCategorias.length > 0 
                                                    ? mueble.codCategorias.map(codigo => categoriasMap[codigo] || codigo).join(", ")
                                                    // Segunda opción: si tiene categorias (strings), usar directamente
                                                    : mueble.categorias && mueble.categorias.length > 0
                                                        ? mueble.categorias.join(", ")
                                                        : null
                                            }
                                            thumbnail={mueble.rutaImagen}
                                            mode={viewMode}
                                            showButton={false}
                                            dotacionesCount={dotaciones.length}
                                            comentarios={comentarios}
                                        />
                                    </>
                                );
                            })}
                        </div>
                    )
                ) : (
                    <div className="mobiliario-central__cards__no-results-message">
                        No se encontraron resultados
                    </div>
                )}

                {visibleCount < filteredMuebles.length && (
                    <div className="mobiliario-central__load-more-container">
                        <Button
                            label="Cargar más"
                            variant="filled"
                            icon={<IoReloadOutline />}
                            onClick={() => setVisibleCount((prev) => prev + 15)}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}
